import { fileTypeLabel } from './visualBuilderComponents'

const CONVERTER_STEP_TYPES = { source: 'inputConverter', destination: 'outputConverter' }
const NOT_SPECIFIED = 'Not specified'

// The converter for one side. Its saved file_type_id is the converter's file_type, or its
// component_type when it has none (converterApplications); every converter of the side's step type
// keyed that way is named, followed by the file type when the converters have one. A saved value no
// converter matches (an older plan, or no catalog) falls back to the saved file type label alone.
const converterValue = (direction, side, components, applications) => {
  const id = side?.file_type_id
  const converters = id
    ? (components || []).filter(component =>
        component.step_type === CONVERTER_STEP_TYPES[direction] && (component.file_type || component.component_type) === id)
    : []
  if (converters.length > 0) {
    const names = converters.map(converter => converter.name).join(', ')
    return converters.some(converter => converter.file_type === id) ? `${names} (${fileTypeLabel(id, applications)})` : names
  }
  return (!side?.unknown && side?.file_type_label) || NOT_SPECIFIED
}

// One side's block: its application and the converter step it feeds. Every slot is written, as
// Not specified when missing, so the AI sees the whole shape of the flow.
const sideLines = (heading, converterLabel, direction, side, components, applications) => [
  heading,
  `Application: ${side?.unknown ? 'Unknown' : side?.application_label || NOT_SPECIFIED}`,
  `${converterLabel}: ${converterValue(direction, side, components, applications)}`
]

// Plain-text prompt for the Visual Builder AI flow builder, describing one planned flow of a vb
// integration in the flow's step order, each piece labelled with the Visual Builder step it feeds:
// the Launcher (the source protocol), the source application and Input Converter, the destination
// application and Output Converter, and the Sender (the destination protocol), then the flow's notes
// verbatim (left out when blank). `integrationType` is the vb catalog entry (its `components`) and
// `applications` the catalog applications; either may be missing.
export const visualBuilderFlowPrompt = ({ integrationName, flow, integrationType, applications }) => {
  const components = integrationType?.components
  const sections = [
    [`Build a Visual Builder flow for the integration "${integrationName}".`],
    [`Flow name: ${flow.name?.trim() || 'Unnamed flow'}`],
    [`Launcher: ${flow.source?.protocol || NOT_SPECIFIED}`],
    sideLines('Source', 'Input Converter', 'source', flow.source, components, applications),
    sideLines('Destination', 'Output Converter', 'destination', flow.destination, components, applications),
    [`Sender: ${flow.destination?.protocol || NOT_SPECIFIED}`]
  ]
  if (flow.notes?.trim()) sections.push(['Notes:', flow.notes])
  return sections.map(lines => lines.join('\n')).join('\n\n')
}
